import axios from 'axios'
import store from '@/store'

const API_BASE = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app/garage'

function getHeaders () {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Token ${store.getters.getToken}`
  }
}

export const garageAPI = {
  // Obtener lista de vehículos
  async getVehicles (params = {}) {
    try {
      const response = await axios.get(`${API_BASE}/vehicles/`, {
        headers: getHeaders(),
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching vehicles:', error)
      throw error
    }
  },

  // Obtener vehículo específico
  async getVehicle (vehicleId) {
    try {
      const response = await axios.get(`${API_BASE}/vehicles/${vehicleId}/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching vehicle:', error)
      throw error
    }
  },

  // Actualizar vehículo
  async updateVehicle (vehicleId, vehicleData) {
    try {
      const response = await axios.patch(`${API_BASE}/vehicles/${vehicleId}/`, vehicleData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error updating vehicle:', error)
      throw error
    }
  },

  // Crear movimiento
  async createMovement (movementData) {
    try {
      const response = await axios.post(`${API_BASE}/movements/`, movementData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error creating movement:', error)
      throw error
    }
  },

  // Obtener historial de movimientos
  async getMovements (params = {}) {
    try {
      const response = await axios.get(`${API_BASE}/movements/`, {
        headers: getHeaders(),
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching movements:', error)
      throw error
    }
  },

  // Obtener movimiento específico
  async getMovement (movementId) {
    try {
      const response = await axios.get(`${API_BASE}/movements/${movementId}/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching movement:', error)
      throw error
    }
  },

  // Crear registro de mantenimiento
  async createMaintenance (maintenanceData) {
    try {
      const response = await axios.post(`${API_BASE}/maintenance/`, maintenanceData, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error creating maintenance:', error)
      throw error
    }
  },

  // Obtener historial de mantenimientos
  async getMaintenanceHistory (params = {}) {
    try {
      const response = await axios.get(`${API_BASE}/maintenance/`, {
        headers: getHeaders(),
        params
      })
      return response.data
    } catch (error) {
      console.error('Error fetching maintenance history:', error)
      throw error
    }
  },

  // Obtener estadísticas de la flotilla
  async getStats () {
    try {
      const response = await axios.get(`${API_BASE}/stats/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching stats:', error)
      throw error
    }
  },

  // Obtener estado de slots (para mapa)
  async getSlotsStatus () {
    try {
      const response = await axios.get(`${API_BASE}/slots/status/`, {
        headers: getHeaders()
      })
      return response.data
    } catch (error) {
      console.error('Error fetching slots status:', error)
      throw error
    }
  }
}

// Utilidades para formatear datos
export const garageUtils = {
  // Obtener color de estado
  getStatusColor (status) {
    const colors = {
      disponible: 'green',
      mantenimiento: 'orange',
      carga: 'info',
      no_disponible: 'red'
    }
    return colors[status] || 'grey'
  },

  // Obtener label de estado
  getStatusLabel (status) {
    const labels = {
      disponible: 'Disponible',
      mantenimiento: 'Mantenimiento',
      carga: 'En Carga',
      no_disponible: 'No Disponible'
    }
    return labels[status] || 'Desconocido'
  },

  // Obtener color de acción
  getActionColor (action) {
    const colors = {
      salida: 'primary',
      retorno: 'success',
      inicio_carga: 'info',
      mantenimiento: 'orange'
    }
    return colors[action] || 'grey'
  },

  // Obtener label de acción
  getActionLabel (action) {
    const labels = {
      salida: 'Salida de Garaje',
      retorno: 'Retorno',
      inicio_carga: 'Inicio Carga',
      mantenimiento: 'Mantenimiento'
    }
    return labels[action] || 'Desconocido'
  },

  // Obtener color de batería
  getBatteryColor (level) {
    if (level >= 75) return 'success'
    if (level >= 50) return 'warning'
    if (level >= 25) return 'orange'
    return 'error'
  },

  // Validar cambio de estado válido
  isValidStatusChange (currentStatus, newStatus) {
    const validTransitions = {
      disponible: ['mantenimiento', 'carga', 'no_disponible'],
      mantenimiento: ['disponible', 'no_disponible'],
      carga: ['disponible', 'no_disponible'],
      no_disponible: ['disponible', 'mantenimiento']
    }
    return validTransitions[currentStatus]?.includes(newStatus) || false
  },

  // Validar datos de vehículo
  isValidVehicleData (data) {
    if (!data.unit_number) return false
    if (!data.brand_model) return false
    if (!data.status) return false
    if (typeof data.battery_level !== 'number') return false
    if (data.battery_level < 0 || data.battery_level > 100) return false
    return true
  },

  // Validar datos de movimiento
  isValidMovementData (data) {
    const validActions = ['salida', 'retorno', 'inicio_carga', 'mantenimiento']
    if (!data.unit_number) return false
    if (!data.action || !validActions.includes(data.action)) return false
    return true
  }
}
